/**
 * Created by iamso on 15.11.2021
 */

const Ruins = function (unit, options) {
    UnitComponent.call(this, unit);

    this.appearTime = options.appearTime || Date.now();

    if (!cleverapps.environment.isEditorScene()) {
        this.activate();
    }

    if (options.appearTime === undefined) {
        cleverapps.effects.fire("merge.ruins.appear");
    }
};

Ruins.prototype = Object.create(UnitComponent.prototype);
Ruins.prototype.constructor = Ruins;

Ruins.prototype.onBlowUp = function (tierName) {
    if (this.view) {
        this.view.blowUp(tierName);
    }
};

Ruins.prototype.activate = function () {
    this.unit.setPrizes({ sprite: bundles.merge.frames.prize_exclamation });
    this.liveTimeout = new cleverapps.LongTimeout(() => {
        if (this.ruinsWinOpen) {
            return;
        }

        this.unit.onDestruction();
        this.unit.remove(true);
    }, this.getTimeLeft());
};

Ruins.prototype.getTimeLeft = function () {
    const timePassed = Date.now() - this.appearTime;
    return Math.max(0, Ruins.LIFETIME - timePassed);
};

Ruins.prototype.buy = function (tierName) {
    const tier = this.getRelevantTier(tierName);

    const rewardsAmount = tier.rewards.reduce((sum, unit) => sum + unit.amount, 0);

    const slotsLacking = rewardsAmount - Map2d.currentMap.countEmptySlots();

    if (slotsLacking > 0) {
        cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left: slotsLacking }));
        return false;
    }

    if (tier.soft || tier.hard) {
        const result = tier.soft ? cleverapps.user.spendSoft(cleverapps.EVENTS.SPENT.RUIN, tier.soft, { source: this.unit })
            : cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.RUIN, tier.hard);
        if (result) {
            this.giveReward(tierName);
        }

        return result;
    }

    return true;
};

Ruins.prototype.getRelevantTier = function (tierName) {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    let tier = (Ruins.TIERS[locationConfig.locationId] || Ruins.TIERS.default)[tierName];

    if (!locationConfig.usesEnergy) {
        tier = cleverapps.clone(tier, true);
        tier.rewards = tier.rewards.filter((unit) => unit.code !== "energy");
    }

    return tier;
};

Ruins.prototype.giveReward = function (tierName) {
    const units = [];

    this.getRelevantTier(tierName).rewards.forEach((data) => {
        for (let i = 0; i < data.amount; ++i) {
            units.push({
                code: data.code,
                stage: data.stage
            });
        }
    });

    cleverapps.focusManager.display({
        focus: "GiveRuinReward",
        stack: true,
        actions: [
            (f) => {
                this.onBlowUp(tierName);
                this.unit.remove(true);

                const delay = cleverapps.config.name === "wondermerge" ? 2800 : 2000;

                Map2dLocation.currentLocation.counter.setTimeout(f, delay);
            },

            (f) => {
                Map2dLocation.currentLocation.spawn(units, this.unit, { spawnSource: "ruins" });
                Map2dLocation.currentLocation.counter.setTimeout(f, 1400);
            }
        ]
    });
};

Ruins.prototype.save = function (data) {
    data.appearTime = this.appearTime;
};

Ruins.prototype.destructor = function () {
    if (this.liveTimeout) {
        clearTimeout(this.liveTimeout);
        delete this.liveTimeout;
    }

    this.destructed = true;
};

Ruins.prototype.handlePrizes = function () {
    this.ruinsWinOpen = true;
    this.unit.squeeze();
    cleverapps.effects.fire("ui.button.click");

    cleverapps.focusManager.display({
        focus: "ruinsWindow",
        stack: true,
        control: ["MenuBarGoldItem", "MenuBarCoinsItem"],
        actions: [
            (f) => {
                if (cleverapps.gameModes.skipOpenChestWindow) {
                    this.giveReward("costly");
                    f();
                } else {
                    new RuinsWindow(this);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            },

            (f) => {
                this.ruinsWinOpen = false;

                if (!this.getTimeLeft() && !this.destructed) {
                    this.unit.onDestruction();
                    this.unit.remove(true);
                }

                f();
            }
        ]
    });

    return true;
};

Ruins.LIFETIME = cleverapps.parseInterval(cleverapps.config.debugMode ? "5 minute" : "1 hours");
Ruins.TIERS = {
    default: {
        cheap: {
            soft: 59,
            rewards: [
                { code: "sacks", stage: 0, amount: 1 },
                { code: "worker", stage: 0, amount: 1 },
                { code: "herochest", stage: 0, amount: 1 }
            ]
        },
        costly: {
            hard: 199,
            rewards: [
                { code: "sacks", stage: 2, amount: 3 },
                { code: "herochest", stage: 2, amount: 3 },
                { code: "worker", stage: 2, amount: 3 },
                { code: "crystal", stage: 3, amount: 1 }
            ]
        }
    }
};
